module.exports = __webpack_public_path__ + "static/media/chips-naturel.9a767220.png";